import { useUnsubscribeMarketingEmails } from "client/actions/users";
import { isMdQuery } from "client/helpers/mediaQuery";
import React, { useCallback } from "react";
import { toast } from "react-toastify";
import { CustomButton } from "../styles";

export default function UnsubscribeCTA({ user }: { user?: string | null }) {
  const isMd = isMdQuery();
  const { mutate, isPending } = useUnsubscribeMarketingEmails({
    onSuccess: () => toast.success("You have been unsubscribed from marketing emails."),
    onError: () =>
      toast.error("Something went wrong, Please check your email address and try again."),
  });

  const handleUnsubscribe = useCallback(async () => {
    if (!user) return toast.error("User not found");
    mutate({ email: user });
  }, [user, mutate]);

  return (
    <CustomButton
      onClick={handleUnsubscribe}
      aria-label="unsubscribe-cta"
      loading={isPending}
      loadingText="Unsubscribing..."
      fullWidth
      size={isMd ? "xl" : "2xl"}
      className="mt-3 mx-auto"
      type="button"
    >
      Unsubscribe
    </CustomButton>
  );
}
